import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    payment: { methods },
  },
} = config

const getRedsysForm = (params) =>
  axios.get(methods, { headers: getHeaders(true), params })

/**
 *
 * @param {object} bodyPayments
 */
const getAllOrders = (bodyPayments) =>
  axios({
    method: 'post',
    url: config.endpoints.plugins.payment.all_payments,
    headers: getHeaders(true),
    data: bodyPayments,
  })

/**
 * Get bookings list or specific user.
 *
 * @param {String} userId Used to get the specific user details
 */
const getPaymentOrdersByUser = (id) =>
  axios({
    url: config.endpoints.plugins.payment.orders.replace(':userId', id),
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Post for create Refund.
 *
 * @param {Object} data Body para el refund
 */
const postRefund = (data) =>
  axios({
    url: config.endpoints.plugins.payment.refund,
    method: 'post',
    headers: getHeaders(true),
    data: data,
  })

/**
 * Get bookings list or specific user and order.
 *
 * @param {String} userId Used to get the specific user details
 * @param {String} orderId Used to get the specific order details
 */
const getPaymentOrderByOrderId = (orderId) =>
  axios({
    url: config.endpoints.plugins.payment.order.replace(':orderId', orderId),
    method: 'get',
    headers: getHeaders(true),
  })

const getOrderId = (body) => axios({
  url: config.endpoints.plugins.payment.payment_id,
  method: 'post',
  headers: getHeaders(true),
  data: body
})

const renewPaymentLink = (body) => axios({
  url: config.endpoints.plugins.payment.renewLink,
  method: 'post',
  data: body,
  headers: getHeaders(true)
})

export default {
  getRedsysForm,
  getPaymentOrdersByUser,
  postRefund,
  getPaymentOrderByOrderId,
  getAllOrders,
  getOrderId, 
  renewPaymentLink
}
